import { LogLevelType, LogLevel } from './index';
import * as moment from 'moment';
import { Request } from 'express';
import { ConsoleLogger } from './console.logger';
import { Logger } from './logger';

export class FormattedConsoleLogger implements Logger {
  private logger: ConsoleLogger;

  private logLevel: number;

  constructor(
    namespace: string,
    logLevelType: LogLevelType,
    private request?: Request & { correlationId?: string },
  ) {
    this.logger = new ConsoleLogger(namespace);
    this.logLevel = LogLevel[logLevelType];
  }

  info(value: any, ...rest: any[]): void {
    if (this.shouldIgnoreLevel(LogLevel.INFO)) {
      return;
    }
    this.logger.info(this.formatMetadata('INFO'), value, ...rest);
  }

  warn(value: any, ...rest: any[]): void {
    if (this.shouldIgnoreLevel(LogLevel.WARN)) {
      return;
    }
    this.logger.warn(this.formatMetadata('WARN'), value, ...rest);
  }

  error(value: any, ...rest: any[]): void {
    if (this.shouldIgnoreLevel(LogLevel.ERROR)) {
      return;
    }
    this.logger.error(this.formatMetadata('ERROR'), value, ...rest);
  }

  private formatMetadata(level: LogLevelType): string {
    const fields = [
      moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
      '-', // empty threadno field
      this.getRequestIp(),
      'DIGICONSO',
      this.getCorrelationId(),
      level,
    ];
    return `${fields.join('|')}|`;
  }

  private getRequestIp(): string {
    return this.request
      && this.request.ip
      || '';
  }

  private getCorrelationId(): string {
    return this.request
      && this.request.correlationId
      || '';
  }

  private shouldIgnoreLevel(levelTested: LogLevel): boolean {
    return this.logLevel < levelTested;
  }
}
